<div class="cp-form-page">
  <button type="button" class="cp-back-link" (click)="goToList()">
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>
    {{ 'commPrevention.form.backToList' | translate }}
  </button>

  <div class="cp-header">
    <div>
      <div class="ct" style="font-size:20px">{{ (mode() === 'create' ? 'commPrevention.form.createTitle' : 'commPrevention.form.editTitle') | translate }}</div>
      <div class="cs">{{ 'commPrevention.form.subtitle' | translate }}</div>
    </div>
  </div>

  <!-- État opérationnel (C6) -- jamais fusionné avec le statut administratif (absent de ce
       formulaire aujourd'hui, voir liste). Uniquement pour BLOCKED/PARTIALLY_BLOCKED : DELIVERABLE/
       NOT_APPLICABLE/absent n'affichent rien (silence = tout va bien). -->
  @if (deliverabilityStatus() === 'BLOCKED') {
    <div class="card cp-deliverability-banner cp-deliverability-banner--blocked">
      <div class="ct">{{ 'commPrevention.form.deliverability.blockedTitle' | translate }}</div>
      <div class="cs">{{ deliverabilityReasonLabel() }}</div>
    </div>
  } @else if (deliverabilityStatus() === 'PARTIALLY_BLOCKED') {
    <div class="card cp-deliverability-banner cp-deliverability-banner--partial">
      <div class="ct">{{ 'commPrevention.form.deliverability.partiallyBlockedTitle' | translate }}</div>
      <div class="cs" style="margin-bottom:8px">{{ 'commPrevention.form.deliverability.partiallyBlockedIntro' | translate: { count: blockedSiteNames().length } }}</div>
      <ul class="cp-blocked-sites-list">
        @for (name of blockedSiteNames(); track name) {
          <li>{{ name }}</li>
        }
      </ul>
    </div>
  }

  @if (loadingCampaign()) {
    <div class="card"><div class="cs" style="text-align:center;padding:40px 0">{{ 'commPrevention.list.loading' | translate }}</div></div>
  } @else {
    <div class="cp-grid">
      <div class="cp-col">
        <div class="card">
          <label class="of-label" for="cpSubject">{{ 'commPrevention.form.subjectLabel' | translate }} *</label>
          <input id="cpSubject" class="input" type="text" maxlength="100"
                 [value]="subject()" (input)="subject.set($any($event.target).value)" (blur)="onSubjectBlurred()"
                 [placeholder]="'commPrevention.form.subjectPlaceholder' | translate">

          <label class="of-label" for="cpTitre" style="margin-top:14px">{{ 'commPrevention.form.titreLabel' | translate }} *</label>
          <input id="cpTitre" class="input" type="text" maxlength="100"
                 [value]="titre()" (input)="titre.set($any($event.target).value)"
                 [placeholder]="'commPrevention.form.titrePlaceholder' | translate">

          <label class="of-label" for="cpTexte" style="margin-top:14px">{{ 'commPrevention.form.texteLabel' | translate }} *</label>
          <div class="textarea-container">
            <textarea #cpTexteArea id="cpTexte" class="textarea-ctrl" rows="4" [attr.maxlength]="TEXTE_MAX_LENGTH"
                      [value]="texte()" (input)="texte.set($any($event.target).value)"
                      [placeholder]="'commPrevention.form.textePlaceholder' | translate"></textarea>
            <button type="button" class="btn-emoji" (click)="toggleEmojiPicker()">😊</button>
            @if (showEmojiPicker()) {
              <emoji-mart class="emoji-picker" (emojiSelect)="addEmoji($event)" [darkMode]="false"></emoji-mart>
            }
          </div>

          <label class="of-label" style="margin-top:14px">{{ 'commPrevention.form.imageLabel' | translate }}</label>
          @if (imageData()) {
            <div class="cp-image-row">
              <img [src]="imageData()" class="cp-image-thumb" alt="">
              <button type="button" class="btn-primary-sm" (click)="removeImage()">{{ 'commPrevention.form.removeImage' | translate }}</button>
            </div>
          } @else {
            <label class="cp-upload-btn">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>
              {{ 'commPrevention.form.importImage' | translate }}
              <input type="file" accept="image/jpeg,image/png,image/webp,application/pdf" (change)="onImageSelect($event)">
            </label>
          }
        </div>

        <div class="card">
          <div class="ct">{{ 'commPrevention.form.typeLabel' | translate }}</div>
          <label class="cp-radio">
            <input type="radio" name="cpType" [checked]="type() === 'PROMOTE_OFFER'" (change)="setType('PROMOTE_OFFER')">
            {{ 'commPrevention.form.typePromote' | translate }}
          </label>
          <label class="cp-radio">
            <input type="radio" name="cpType" [checked]="type() === 'TEST_INTEREST'" (change)="setType('TEST_INTEREST')">
            {{ 'commPrevention.form.typeInterest' | translate }}
          </label>

          @if (type() === 'PROMOTE_OFFER') {
            <label class="of-label" for="cpOffer" style="margin-top:14px">{{ 'commPrevention.form.offerLabel' | translate }} *</label>
            <select id="cpOffer" class="select-ctrl" (change)="onOfferChanged($any($event.target).value)">
              <option value="" [selected]="!selectedOfferId()">{{ 'commPrevention.form.offerPlaceholder' | translate }}</option>
              @for (o of offers(); track o.offerId) {
                <option [value]="o.offerId" [selected]="o.offerId === selectedOfferId()">{{ o.name }}</option>
              }
            </select>
          }
        </div>

        <div class="card">
          <div class="ct">{{ 'commPrevention.form.diffusionLabel' | translate }}</div>
          @if (mode() === 'create') {
            <label class="cp-radio">
              <input type="radio" name="cpScope" [checked]="scope() === 'ALL'" (change)="setScope('ALL')">
              {{ 'commPrevention.form.diffusionAll' | translate }}
              @if (type() === 'PROMOTE_OFFER' && offerId()) {
                <span class="cs">({{ 'commPrevention.form.diffusionEligibleCount' | translate: { eligible: eligibleCount(), total: totalSitesCount() } }})</span>
              }
            </label>
            <label class="cp-radio">
              <input type="radio" name="cpScope" [checked]="scope() === 'SITES'" (change)="setScope('SITES')">
              {{ 'commPrevention.form.diffusionSites' | translate }}
            </label>

            @if (scope() === 'SITES') {
              <app-site-multi-select
                [sites]="siteOptions()"
                [selectedIds]="selectedSiteIds()"
                (selectedIdsChange)="selectedSiteIds.set($event)">
              </app-site-multi-select>
            }
          } @else if (isEnded()) {
            <div class="cs" style="margin-bottom:8px">{{ 'commPrevention.form.diffusionEndedNote' | translate }}</div>
            <div class="cp-site-list">
              @for (site of campaignSites(); track site.establishmentId) {
                <div class="cp-site-row cp-site-row--static">{{ site.name }}</div>
              }
            </div>
          } @else {
            <app-site-multi-select
              [sites]="siteOptions()"
              [selectedIds]="selectedSiteIds()"
              (selectedIdsChange)="selectedSiteIds.set($event)">
            </app-site-multi-select>
          }

          @if (sitesError()) {
            <div class="cp-field-error">{{ sitesError() }}</div>
          }
        </div>

        <div class="card">
          <div class="ct">{{ 'commPrevention.form.datesLabel' | translate }}</div>
          <label class="of-label">{{ 'commPrevention.form.startsAtLabel' | translate }}</label>
          <app-date-time-picker [value]="startsAtLocal()" (valueChange)="onStartsAtChanged($event)"></app-date-time-picker>

          <label class="of-label" style="margin-top:14px">{{ 'commPrevention.form.endsAtLabel' | translate }}</label>
          <app-date-time-picker [value]="endsAtLocal()" [minValue]="startsAtLocal()" (valueChange)="onEndsAtChanged($event)"></app-date-time-picker>

          @if (dateError()) {
            <div class="cp-field-error">{{ dateError() }}</div>
          }
        </div>
      </div>

      <div class="cp-col">
        <div class="card">
          <div class="ct">{{ 'commPrevention.form.previewLabel' | translate }}</div>
          <div class="cp-preview-card">
            @if (imageData()) {
              <img [src]="imageData()" class="cp-preview-img" alt="">
            }
            <div class="cp-preview-title">{{ titre() || ('commPrevention.form.previewTitlePlaceholder' | translate) }}</div>
            <div class="cp-preview-text">{{ texte() || ('commPrevention.form.previewTextPlaceholder' | translate) }}</div>
            <button type="button" class="cp-preview-cta" disabled>
              {{ (type() === 'PROMOTE_OFFER' ? 'commPrevention.form.previewCtaOffer' : 'commPrevention.form.previewCtaInterest') | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>

    @if (errorMessage()) {
      <div class="card cp-error-card" style="margin-bottom:16px">{{ errorMessage() }}</div>
    }

    <div class="cp-submit-row">
      <button class="btn-primary-sm" (click)="cancel()">{{ 'commPrevention.form.cancelButton' | translate }}</button>
      <button class="btn-submit-primary" [disabled]="!isValid() || saving()" (click)="submit()">
        {{ (saving() ? 'commPrevention.form.savingButton' : (mode() === 'create' ? 'commPrevention.form.createButton' : 'commPrevention.form.saveButton')) | translate }}
      </button>
    </div>

    @if (showSitesConfirm()) {
      <app-confirm-modal
        [title]="'commPrevention.confirm.sitesChangeTitle' | translate"
        [message]="'commPrevention.confirm.sitesChangeMessage' | translate"
        [confirmText]="'commPrevention.confirm.confirmSitesButton' | translate"
        [cancelText]="'commPrevention.confirm.cancelButton' | translate"
        [loading]="saving()"
        (confirm)="confirmSitesChange()"
        (cancel)="cancelSitesChange()">
      </app-confirm-modal>
    }
  }
</div>
